const CLASSES = {
  default: "brh-composition-content",
  elements: {
    get main() {
      return `.${CLASSES.default}`;
    },
    get panelLeft() {
      return `.brh-composition-content__panel-left`;
    },
  },
  layouts: {
    get twoTextBlocks() {
      return `${CLASSES.elements.main}--two-text-blocks`;
    },
    get twoMultimediaBlocks() {
      return `${CLASSES.elements.main}--two-multimedia-blocks`;
    },
    get threeMultimedia() {
      return `${CLASSES.elements.main}--three-multimedia`;
    },
    get threeMultimediaCollage() {
      return `${CLASSES.elements.main}--three-multimedia-collage`;
    },
    get sixMultimedia() {
      return `${CLASSES.elements.main}--six-multimedia`;
    },
  },
};

export default CLASSES;
